import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../_virtual/_rollupPluginBabelHelpers.js';
import { getIdSet } from './getIdSet.js';
import difference from 'lodash/difference.js';
import flatMap from 'lodash/flatMap.js';
import flatten from 'lodash/flatten.js';
import union from 'lodash/union.js';

/**
 * Allows selecting all records for paginated results
 */
var selectAll = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var endpoint, filters, query, isChecked, totalCount, selectedIds, entity, sortValue, authToken, _ref$skipInactive, skipInactive, pageSize, numberOfRequests, functionArray, count, values, flattened, filtered, skipped, newArray, selected;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          endpoint = _ref.endpoint, filters = _ref.filters, query = _ref.query, isChecked = _ref.isChecked, totalCount = _ref.totalCount, selectedIds = _ref.selectedIds, entity = _ref.entity, sortValue = _ref.sortValue, authToken = _ref.authToken, _ref$skipInactive = _ref.skipInactive, skipInactive = _ref$skipInactive === undefined ? false : _ref$skipInactive;
          pageSize = 1000;
          numberOfRequests = Math.ceil(totalCount / pageSize);
          functionArray = [];
          for (count = 0; count < numberOfRequests; count++) {
            functionArray.push(getIdSet);
          }
          _context.prev = 5;
          _context.next = 8;
          return Promise.all(functionArray.map(function (func, index) {
            var extraFields = skipInactive ? 'active' : null;
            // @ts-ignore
            return func({
              endpoint: endpoint,
              filters: filters,
              page: index + 1,
              pageSize: pageSize,
              query: query,
              entity: entity,
              sortValue: sortValue,
              authToken: authToken,
              extraFields: extraFields
            });
          }));
        case 8:
          values = _context.sent;
          flattened = flatMap(values, function (f) {
            return f.data;
          });
          filtered = skipInactive ? flattened.filter(function (item) {
            return !!item.attributes && item.attributes.active;
          }) : flattened;
          skipped = skipInactive && isChecked ? flattened.filter(function (item) {
            return !!item.attributes && !item.attributes.active;
          }).map(function (item) {
            return item.id;
          }) : [];
          newArray = filtered.map(function (item) {
            return item.id;
          });
          selected = [];
          if (isChecked) {
            // selecting all
            // @ts-ignore
            selected = flatten(union([selectedIds, newArray]));
          } else {
            // deselecting all
            // @ts-ignore
            selected = difference(selectedIds, newArray);
          }
          return _context.abrupt("return", skipInactive ? {
            selected: selected,
            skipped: skipped
          } : selected);
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](5);
          return _context.abrupt("return", []);
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 18]]);
  }));
  return function selectAll(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export { selectAll };